import React from "react"
import "./ViewBar.css"
import { Link } from "react-router-dom"

export default function Viewbar(props) {
  const { user, isViewAsTeacher, tabProfileActive, tabVetResumeActive } = props
  // let roleControlToggle;
  let viewBarInfo
  let internalLink
  let tolink

  if (isViewAsTeacher) {
    viewBarInfo = user?.is_childhood_teacher ? "You are viewing Profile as Educator" : "You are viewing Profile as Teacher"
    // internalLink = <Link title="Ready Teacher" to={`/PreviewProfile2`} >View as College</Link>
    //Yuan: redux
    tolink = tabProfileActive ? `/previewProfile` : tabVetResumeActive? `/PreviewVetResume` : `/previewResume`
    tolink = !tabProfileActive && user?.is_childhood_teacher ? "/previewEcecResume" : tolink
    internalLink = (
      <Link title="Ready Teacher" to={tolink}>
        View as College
      </Link>
    )
  } else {
    viewBarInfo = "You are viewing Profile as College"
    // internalLink = <Link title="Ready Teacher" to={`/home2`}>View as Teacher</Link>
    //Yuan: redux
    tolink = tabProfileActive ? `/` : tabVetResumeActive? `/VocationalResume` :`/resume`
    tolink = !tabProfileActive && user?.is_childhood_teacher ? "/ececResume" : tolink
    internalLink = (
      <Link title="Ready Teacher" to={tolink}>
        {user?.is_childhood_teacher ? "View as Educator" : "View as Teacher"}
      </Link>
    )
  }

  return (
    <div className="review-control-bar">
      <div className="review-control-bar-virtual-div"></div>
      <div>{viewBarInfo}</div>
      <div className="role-control-toggle">{internalLink}</div>
    </div>
  )
}
